// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.MobileLanguageInfo-space1-opuMF {
	margin-bottom: 6px !important;
}

.MobileLanguageInfo-space2-Ktz0x {
	margin-bottom: 12px !important;
}

.MobileLanguageInfo-space3-ODkVd {
	margin-bottom: 18px !important;
}

.MobileLanguageInfo-space4-KKZVE {
	margin-bottom: 24px !important;
}

.MobileLanguageInfo-space5-Ixdco {
	margin-bottom: 30px !important;
}

.MobileLanguageInfo-space6-IOlns {
	margin-bottom: 36px !important;
}

.MobileLanguageInfo-space7-iSaDK {
	margin-bottom: 42px !important;
}

.MobileLanguageInfo-space8-FZU5w {
	margin-bottom: 48px !important;
}

.MobileLanguageInfo-spaceTop1-OryOt {
	margin-top: 6px !important;
}

.MobileLanguageInfo-spaceTop2-MSP79 {
	margin-top: 12px !important;
}

.MobileLanguageInfo-spaceTop3-E69Pg {
	margin-top: 18px !important;
}

.MobileLanguageInfo-spaceTop4-nDLuy {
	margin-top: 24px !important;
}

.MobileLanguageInfo-spaceTop5-GhrCz {
	margin-top: 30px !important;
}

.MobileLanguageInfo-spaceTop6-OTg3H {
	margin-top: 36px !important;
}

.MobileLanguageInfo-spaceTop7-WHuFW {
	margin-top: 42px !important;
}

.MobileLanguageInfo-spaceTop8-XBZhO {
	margin-top: 48px !important;
}

.MobileLanguageInfo-noMargin-w5pgk {
	margin: 0px !important;
}

.MobileLanguageInfo-padding1-iI4cj {
	padding-bottom: 6px !important;
}

.MobileLanguageInfo-padding2-yDCmL {
	padding-bottom: 12px !important;
}

.MobileLanguageInfo-padding3-eVNNP {
	padding-bottom: 18px !important;
}

.MobileLanguageInfo-padding4-BHTAY {
	padding-bottom: 24px !important;
}

.MobileLanguageInfo-padding5-wixrd {
	padding-bottom: 30px !important;
}

.MobileLanguageInfo-padding6-ts6vK {
	padding-bottom: 36px !important;
}

.MobileLanguageInfo-padding7-whFqO {
	padding-bottom: 42px !important;
}

.MobileLanguageInfo-paddingTop1-fW9Tt {
	padding-top: 6px !important;
}

.MobileLanguageInfo-paddingTop2-ztiaB {
	padding-top: 12px !important;
}

.MobileLanguageInfo-paddingTop3-r5nwO {
	padding-top: 18px !important;
}

.MobileLanguageInfo-paddingTop4-AVeBx {
	padding-top: 24px !important;
}

.MobileLanguageInfo-paddingTop5-VCLXk {
	padding-top: 30px !important;
}

.MobileLanguageInfo-paddingTop6-Sfi9q {
	padding-top: 36px !important;
}

.MobileLanguageInfo-paddingTop7-wHDoQ {
	padding-top: 42px !important;
}

.MobileLanguageInfo-noPadding-tfprL {
	padding: 0px !important;
}

.MobileLanguageInfo-spaceMarginBottom0-B2r2F {
	margin-bottom: 0;
}

.MobileLanguageInfo-textBold-LD2GT {
	font-weight: 500 !important;
}

.MobileLanguageInfo-textBolder-iiF29 {
	font-weight: 700 !important;
}

.MobileLanguageInfo-textNormal-TPukq {
	font-weight: normal !important;
}

/*New Design Text Colors */

.MobileLanguageInfo-textDarkBlue-MR91C {
	color: rgb(20, 39, 94) !important;
}

.MobileLanguageInfo-textLightBlue-FRj8a {
	color: rgb(57, 87, 106) !important;
}

.MobileLanguageInfo-textLightSandleGreen-YYdry {
	color: rgb(76, 86, 41) !important;
}

.MobileLanguageInfo-textLightBrown-SMOVS {
	color: rgb(115, 79, 33) !important;
}

.MobileLanguageInfo-textMediumMaroon-qVBVS {
	color: rgb(87, 37, 51) !important;
}

.MobileLanguageInfo-textBrown-xHkQA {
	color: rgb(160, 47, 24) !important;
}

.MobileLanguageInfo-textMaroon-CCm0L {
	color: rgb(155, 49, 67) !important;
}

.MobileLanguageInfo-textDarkBrown-nwbTy {
	color: rgb(83, 18, 16) !important;
}

.MobileLanguageInfo-textMediumBrown-XUC4j {
	color: rgb(142, 28, 10) !important;
}

.MobileLanguageInfo-textSkyBlue-dXyMb {
	color: rgb(37, 117, 141) !important;
}

.MobileLanguageInfo-textGray-B89Gv {
	color: rgb(77, 65, 51) !important;
}

.MobileLanguageInfo-errorMessage-k1dWe {
  margin-top: 5px;
  margin-bottom: 5px;
  display: block;
  color: var(--alert-color);
  font-size: 14px;
  font-weight: normal;
  /* margin-left: 5px; */
}

/** Admin - Common - Start **/

.MobileLanguageInfo-userText-Vhuwg {
	padding-top: 3px;
	color: var(--common-text-color);
	margin: 0px;
	font-size: 14px;
}

.MobileLanguageInfo-panelHeader-x0dsD {
	border-radius: 4px;
	padding: 20px 25px;
	border: 1px solid var(--primary-border);
}

.MobileLanguageInfo-exportSection-XQNON {
	background: var(--common-gray-bg-color);
	padding: 24px 15px;
	display: grid;
	grid-template-columns: 28% 15% 55%;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	grid-gap: 11px;
	border: 1px solid var(--primary-border);
	border-bottom: 0;
	border-top-left-radius: 20px;
	border-top-right-radius: 20px;
}

.MobileLanguageInfo-exportSectionGridSub-_Cbub {
	grid-template-columns: 50% 49% !important;
}

.MobileLanguageInfo-exportText-WfYD0 {
	color: var(--common-text-color) !important;
	text-decoration: none !important;
	display: inline-block;
	float: right;
}

.MobileLanguageInfo-exportLinkImg-gqarK {
	background: var(--primary-white-bg);
	padding: 10px;
	margin-left: 12px;
	border-radius: 4px;
}

.MobileLanguageInfo-exportImg-KCItX {
	width: 100%;
	max-width: 16px;
	vertical-align: middle;
}

.MobileLanguageInfo-linkBtn-wBV8y {
	line-height: 24px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 15px;
	text-align: center;
}

.MobileLanguageInfo-table-o4jFh {
	display: table;
}

.MobileLanguageInfo-tableRow-il90z {
	display: table-row;
}

.MobileLanguageInfo-tableCell-XPnaz {
	display: table-cell;
	float: none;
}

.MobileLanguageInfo-formGroup-rsiLY {
	margin-bottom: 6px;
}

.MobileLanguageInfo-marginTop0-lEYPg {
	margin-top: 0;
}

.MobileLanguageInfo-marginBottom20-hfSG6 {
	margin-bottom: 20px;
}

/******************* Admin Banner Image Section Start ****************/

.MobileLanguageInfo-bannerImageBg-Nii7B {
	width: 100%;
	height: 100%;
	min-height: 179px;
	background-size: contain;
	background-repeat: no-repeat;
	background-position: 50% 50%;
	position: relative;
	border-radius: 0px;
}

.MobileLanguageInfo-bannerDelete-rxkWc {
	position: absolute;
	top: 5px;
	right: 20px;
}

/*******************Admin Modal Start **********************/

a,
a:hover {
	cursor: pointer;
}

.MobileLanguageInfo-exportLink-_hVTc {
	padding-top: 10px;
	padding-right: 10px;
}

.MobileLanguageInfo-seachContent-iT1tZ {
	padding-left: 0px;
	margin-bottom: 5px;
}

.MobileLanguageInfo-marginBottom9-SsHSd {
	margin-bottom: 9px;
}

.MobileLanguageInfo-spaceTop52-VqdJP {
	margin-top: 52px;
}

.MobileLanguageInfo-profileViewInner-xDaBJ {
	padding: 10px;
	border-top: 1px solid var(--primary-border);
	word-break: break-all;
}

.MobileLanguageInfo-profileViewMain-QDdBL {
	border: 1px solid var(--primary-border);
	border-radius: 0px;
	border-top: 0;
}

.MobileLanguageInfo-profileViewlabel-HEDtB {
	display: inline-block;
	width: 38%;
	vertical-align: middle;
}

.MobileLanguageInfo-profileViewMainContent-SdQbn {
	display: inline-block;
	width: 62%;
	vertical-align: middle;
}

.MobileLanguageInfo-reviewsFormStar-UuJUm {
	font-size: 32px;
	display: -webkit-box;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	    -ms-flex-align: center;
	        align-items: center;
	gap: 2px;
	-ms-flex-wrap: wrap;
	    flex-wrap: wrap;
}

.MobileLanguageInfo-reviewsFormStar-UuJUm svg {
	cursor: pointer;
}

.MobileLanguageInfo-addLanguageText-jv2xL {
	font-size: 16px;
}

/***************** Export Section Start *********************/

@media screen and (max-width: 991px) {
	.MobileLanguageInfo-exportSection-XQNON {
		grid-template-columns: 100%;
	}

	.MobileLanguageInfo-spaceTop52-VqdJP {
		margin-top: 18px;
	}

	.MobileLanguageInfo-exportText-WfYD0 {
		float: none;
		margin-top: 12px;
	}

	.MobileLanguageInfo-exportSectionGridSub-_Cbub {
		grid-template-columns: 100% !important;
	}
}

/***************** Export Section End *********************/

/*******************Admin Modal Start **********************/

/*******************Admin Modal End **********************/

/*********************** Profile View Section  Start***********************/

@media screen and (max-width: 767px) {
	.MobileLanguageInfo-profileViewlabel-HEDtB {
		width: 100%;
		margin-bottom: 6px;
		text-align: center;
	}

	.MobileLanguageInfo-profileViewMainContent-SdQbn {
		width: 100%;
		text-align: center;
	}

	.MobileLanguageInfo-panelHeader-x0dsD {
		padding: 15px 15px;
	}

}

/*********************** Profile View Section  Start***********************/

.MobileLanguageInfo-noMargin-w5pgk {
    margin: 0px;
}`, "",{"version":3,"sources":["webpack://./src/components/helpers.css","webpack://./src/components/utils.css","webpack://./src/components/siteadmin/admin-common.css","webpack://./src/components/siteadmin/MobileLanguageInfo/MobileLanguageInfo.css"],"names":[],"mappings":"AAAA;CACC,6BAA6B;AAC9B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,0BAA0B;AAC3B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,sBAAsB;AACvB;;AAEA;CACC,8BAA8B;AAC/B;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,+BAA+B;AAChC;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,4BAA4B;AAC7B;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,2BAA2B;AAC5B;;AAEA;CACC,8BAA8B;AAC/B;;AAEA,0BAA0B;;AAE1B;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,iCAAiC;AAClC;;AAEA;CACC,kCAAkC;AACnC;;AAEA;CACC,mCAAmC;AACpC;;AAEA;CACC,iCAAiC;AAClC;;AC5LA;EACE,eAAe;EACf,kBAAkB;EAClB,cAAc;EACd,yBAAyB;EACzB,eAAe;EACf,mBAAmB;EACnB,sBAAsB;AACxB;;ACLA,6BAA6B;;AAC7B;CACC,gBAAgB;CAChB,+BAA+B;CAC/B,WAAW;CACX,eAAe;AAChB;;AAEA;CACC,kBAAkB;CAClB,kBAAkB;CAClB,uCAAuC;AACxC;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;CACb,kCAAkC;CAClC,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,cAAc;CACd,uCAAuC;CACvC,gBAAgB;CAChB,4BAA4B;CAC5B,6BAA6B;AAC9B;;AAEA;CACC,yCAAyC;AAC1C;;AAEA;CACC,0CAA0C;CAC1C,gCAAgC;CAChC,qBAAqB;CACrB,YAAY;AACb;;AAEA;CACC,mCAAmC;CACnC,aAAa;CACb,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,WAAW;CACX,eAAe;CACf,sBAAsB;AACvB;;AAEA;CACC,iBAAiB;CACjB,qBAAqB;CACrB,sBAAsB;CACtB,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,mBAAmB;CACnB,WAAW;AACZ;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAGA,sEAAsE;;AACtE;CACC,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,wBAAwB;CACxB,4BAA4B;CAC5B,4BAA4B;CAC5B,kBAAkB;CAClB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;CAClB,QAAQ;CACR,WAAW;AACZ;;AAEA,4DAA4D;;AAC5D;;CAEC,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;;AAEA;CACC,iBAAiB;CACjB,kBAAkB;AACnB;;AAEA;CACC,kBAAkB;AACnB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,2CAA2C;CAC3C,qBAAqB;AACtB;;AAEA;CACC,uCAAuC;CACvC,kBAAkB;CAClB,aAAa;AACd;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,qBAAqB;CACrB,UAAU;CACV,sBAAsB;AACvB;;AAEA;CACC,eAAe;CACf,oBAAa;CAAb,oBAAa;CAAb,aAAa;CACb,yBAAmB;KAAnB,sBAAmB;SAAnB,mBAAmB;CACnB,QAAQ;CACR,mBAAe;KAAf,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,eAAe;AAChB;;AAEA,6DAA6D;;AAC7D;CACC;EACC,2BAA2B;CAC5B;;CAEA;EACC,gBAAgB;CACjB;;CAEA;EACC,WAAW;EACX,gBAAgB;CACjB;;CAEA;EACC,sCAAsC;CACvC;AACD;;AAEA,2DAA2D;;AAC3D,4DAA4D;;AAE5D,0DAA0D;;AAE1D,2EAA2E;;AAG3E;CACC;EACC,WAAW;EACX,kBAAkB;EAClB,kBAAkB;CACnB;;CAEA;EACC,WAAW;EACX,kBAAkB;CACnB;;CAEA;EACC,kBAAkB;CACnB;;AAED;;AAEA,2EAA2E;;ACtN3E;IACI,WAAW;AACf","sourcesContent":[".space1 {\n\tmargin-bottom: 6px !important;\n}\n\n.space2 {\n\tmargin-bottom: 12px !important;\n}\n\n.space3 {\n\tmargin-bottom: 18px !important;\n}\n\n.space4 {\n\tmargin-bottom: 24px !important;\n}\n\n.space5 {\n\tmargin-bottom: 30px !important;\n}\n\n.space6 {\n\tmargin-bottom: 36px !important;\n}\n\n.space7 {\n\tmargin-bottom: 42px !important;\n}\n\n.space8 {\n\tmargin-bottom: 48px !important;\n}\n\n.spaceTop1 {\n\tmargin-top: 6px !important;\n}\n\n.spaceTop2 {\n\tmargin-top: 12px !important;\n}\n\n.spaceTop3 {\n\tmargin-top: 18px !important;\n}\n\n.spaceTop4 {\n\tmargin-top: 24px !important;\n}\n\n.spaceTop5 {\n\tmargin-top: 30px !important;\n}\n\n.spaceTop6 {\n\tmargin-top: 36px !important;\n}\n\n.spaceTop7 {\n\tmargin-top: 42px !important;\n}\n\n.spaceTop8 {\n\tmargin-top: 48px !important;\n}\n\n.noMargin {\n\tmargin: 0px !important;\n}\n\n.padding1 {\n\tpadding-bottom: 6px !important;\n}\n\n.padding2 {\n\tpadding-bottom: 12px !important;\n}\n\n.padding3 {\n\tpadding-bottom: 18px !important;\n}\n\n.padding4 {\n\tpadding-bottom: 24px !important;\n}\n\n.padding5 {\n\tpadding-bottom: 30px !important;\n}\n\n.padding6 {\n\tpadding-bottom: 36px !important;\n}\n\n.padding7 {\n\tpadding-bottom: 42px !important;\n}\n\n.paddingTop1 {\n\tpadding-top: 6px !important;\n}\n\n.paddingTop2 {\n\tpadding-top: 12px !important;\n}\n\n.paddingTop3 {\n\tpadding-top: 18px !important;\n}\n\n.paddingTop4 {\n\tpadding-top: 24px !important;\n}\n\n.paddingTop5 {\n\tpadding-top: 30px !important;\n}\n\n.paddingTop6 {\n\tpadding-top: 36px !important;\n}\n\n.paddingTop7 {\n\tpadding-top: 42px !important;\n}\n\n.noPadding {\n\tpadding: 0px !important;\n}\n\n.spaceMarginBottom0 {\n\tmargin-bottom: 0;\n}\n\n.textBold {\n\tfont-weight: 500 !important;\n}\n\n.textBolder {\n\tfont-weight: 700 !important;\n}\n\n.textNormal {\n\tfont-weight: normal !important;\n}\n\n/*New Design Text Colors */\n\n.textDarkBlue {\n\tcolor: rgb(20, 39, 94) !important;\n}\n\n.textLightBlue {\n\tcolor: rgb(57, 87, 106) !important;\n}\n\n.textLightSandleGreen {\n\tcolor: rgb(76, 86, 41) !important;\n}\n\n.textLightBrown {\n\tcolor: rgb(115, 79, 33) !important;\n}\n\n.textMediumMaroon {\n\tcolor: rgb(87, 37, 51) !important;\n}\n\n.textBrown {\n\tcolor: rgb(160, 47, 24) !important;\n}\n\n.textMaroon {\n\tcolor: rgb(155, 49, 67) !important;\n}\n\n.textDarkBrown {\n\tcolor: rgb(83, 18, 16) !important;\n}\n\n.textMediumBrown {\n\tcolor: rgb(142, 28, 10) !important;\n}\n\n.textSkyBlue {\n\tcolor: rgb(37, 117, 141) !important;\n}\n\n.textGray {\n\tcolor: rgb(77, 65, 51) !important;\n}",".errorMessage {\n  margin-top: 5px;\n  margin-bottom: 5px;\n  display: block;\n  color: var(--alert-color);\n  font-size: 14px;\n  font-weight: normal;\n  /* margin-left: 5px; */\n}","@import '../helpers.css';\n@import '../utils.css';\n\n/** Admin - Common - Start **/\n.userText {\n\tpadding-top: 3px;\n\tcolor: var(--common-text-color);\n\tmargin: 0px;\n\tfont-size: 14px;\n}\n\n.panelHeader {\n\tborder-radius: 4px;\n\tpadding: 20px 25px;\n\tborder: 1px solid var(--primary-border);\n}\n\n.exportSection {\n\tbackground: var(--common-gray-bg-color);\n\tpadding: 24px 15px;\n\tdisplay: grid;\n\tgrid-template-columns: 28% 15% 55%;\n\talign-items: center;\n\tgrid-gap: 11px;\n\tborder: 1px solid var(--primary-border);\n\tborder-bottom: 0;\n\tborder-top-left-radius: 20px;\n\tborder-top-right-radius: 20px;\n}\n\n.exportSectionGridSub {\n\tgrid-template-columns: 50% 49% !important;\n}\n\n.exportText {\n\tcolor: var(--common-text-color) !important;\n\ttext-decoration: none !important;\n\tdisplay: inline-block;\n\tfloat: right;\n}\n\n.exportLinkImg {\n\tbackground: var(--primary-white-bg);\n\tpadding: 10px;\n\tmargin-left: 12px;\n\tborder-radius: 4px;\n}\n\n.exportImg {\n\twidth: 100%;\n\tmax-width: 16px;\n\tvertical-align: middle;\n}\n\n.linkBtn {\n\tline-height: 24px;\n\tdisplay: inline-block;\n\tvertical-align: middle;\n\tmargin-right: 15px;\n\ttext-align: center;\n}\n\n.table {\n\tdisplay: table;\n}\n\n.tableRow {\n\tdisplay: table-row;\n}\n\n.tableCell {\n\tdisplay: table-cell;\n\tfloat: none;\n}\n\n.formGroup {\n\tmargin-bottom: 6px;\n}\n\n.marginTop0 {\n\tmargin-top: 0;\n}\n\n.marginBottom20 {\n\tmargin-bottom: 20px;\n}\n\n\n/******************* Admin Banner Image Section Start ****************/\n.bannerImageBg {\n\twidth: 100%;\n\theight: 100%;\n\tmin-height: 179px;\n\tbackground-size: contain;\n\tbackground-repeat: no-repeat;\n\tbackground-position: 50% 50%;\n\tposition: relative;\n\tborder-radius: 0px;\n}\n\n.bannerDelete {\n\tposition: absolute;\n\ttop: 5px;\n\tright: 20px;\n}\n\n/*******************Admin Modal Start **********************/\na,\na:hover {\n\tcursor: pointer;\n}\n\n.exportLink {\n\tpadding-top: 10px;\n\tpadding-right: 10px;\n}\n\n.seachContent {\n\tpadding-left: 0px;\n\tmargin-bottom: 5px;\n}\n\n.marginBottom9 {\n\tmargin-bottom: 9px;\n}\n\n.spaceTop52 {\n\tmargin-top: 52px;\n}\n\n.profileViewInner {\n\tpadding: 10px;\n\tborder-top: 1px solid var(--primary-border);\n\tword-break: break-all;\n}\n\n.profileViewMain {\n\tborder: 1px solid var(--primary-border);\n\tborder-radius: 0px;\n\tborder-top: 0;\n}\n\n.profileViewlabel {\n\tdisplay: inline-block;\n\twidth: 38%;\n\tvertical-align: middle;\n}\n\n.profileViewMainContent {\n\tdisplay: inline-block;\n\twidth: 62%;\n\tvertical-align: middle;\n}\n\n.reviewsFormStar {\n\tfont-size: 32px;\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 2px;\n\tflex-wrap: wrap;\n}\n\n.reviewsFormStar svg {\n\tcursor: pointer;\n}\n\n.addLanguageText {\n\tfont-size: 16px;\n}\n\n/***************** Export Section Start *********************/\n@media screen and (max-width: 991px) {\n\t.exportSection {\n\t\tgrid-template-columns: 100%;\n\t}\n\n\t.spaceTop52 {\n\t\tmargin-top: 18px;\n\t}\n\n\t.exportText {\n\t\tfloat: none;\n\t\tmargin-top: 12px;\n\t}\n\n\t.exportSectionGridSub {\n\t\tgrid-template-columns: 100% !important;\n\t}\n}\n\n/***************** Export Section End *********************/\n/*******************Admin Modal Start **********************/\n\n/*******************Admin Modal End **********************/\n\n/*********************** Profile View Section  Start***********************/\n\n\n@media screen and (max-width: 767px) {\n\t.profileViewlabel {\n\t\twidth: 100%;\n\t\tmargin-bottom: 6px;\n\t\ttext-align: center;\n\t}\n\n\t.profileViewMainContent {\n\t\twidth: 100%;\n\t\ttext-align: center;\n\t}\n\n\t.panelHeader {\n\t\tpadding: 15px 15px;\n\t}\n\n}\n\n/*********************** Profile View Section  Start***********************/","@import '../admin-common.css';\n@import '../../helpers.css';\n.noMargin {\n    margin: 0px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"space1": `MobileLanguageInfo-space1-opuMF`,
	"space2": `MobileLanguageInfo-space2-Ktz0x`,
	"space3": `MobileLanguageInfo-space3-ODkVd`,
	"space4": `MobileLanguageInfo-space4-KKZVE`,
	"space5": `MobileLanguageInfo-space5-Ixdco`,
	"space6": `MobileLanguageInfo-space6-IOlns`,
	"space7": `MobileLanguageInfo-space7-iSaDK`,
	"space8": `MobileLanguageInfo-space8-FZU5w`,
	"spaceTop1": `MobileLanguageInfo-spaceTop1-OryOt`,
	"spaceTop2": `MobileLanguageInfo-spaceTop2-MSP79`,
	"spaceTop3": `MobileLanguageInfo-spaceTop3-E69Pg`,
	"spaceTop4": `MobileLanguageInfo-spaceTop4-nDLuy`,
	"spaceTop5": `MobileLanguageInfo-spaceTop5-GhrCz`,
	"spaceTop6": `MobileLanguageInfo-spaceTop6-OTg3H`,
	"spaceTop7": `MobileLanguageInfo-spaceTop7-WHuFW`,
	"spaceTop8": `MobileLanguageInfo-spaceTop8-XBZhO`,
	"noMargin": `MobileLanguageInfo-noMargin-w5pgk`,
	"padding1": `MobileLanguageInfo-padding1-iI4cj`,
	"padding2": `MobileLanguageInfo-padding2-yDCmL`,
	"padding3": `MobileLanguageInfo-padding3-eVNNP`,
	"padding4": `MobileLanguageInfo-padding4-BHTAY`,
	"padding5": `MobileLanguageInfo-padding5-wixrd`,
	"padding6": `MobileLanguageInfo-padding6-ts6vK`,
	"padding7": `MobileLanguageInfo-padding7-whFqO`,
	"paddingTop1": `MobileLanguageInfo-paddingTop1-fW9Tt`,
	"paddingTop2": `MobileLanguageInfo-paddingTop2-ztiaB`,
	"paddingTop3": `MobileLanguageInfo-paddingTop3-r5nwO`,
	"paddingTop4": `MobileLanguageInfo-paddingTop4-AVeBx`,
	"paddingTop5": `MobileLanguageInfo-paddingTop5-VCLXk`,
	"paddingTop6": `MobileLanguageInfo-paddingTop6-Sfi9q`,
	"paddingTop7": `MobileLanguageInfo-paddingTop7-wHDoQ`,
	"noPadding": `MobileLanguageInfo-noPadding-tfprL`,
	"spaceMarginBottom0": `MobileLanguageInfo-spaceMarginBottom0-B2r2F`,
	"textBold": `MobileLanguageInfo-textBold-LD2GT`,
	"textBolder": `MobileLanguageInfo-textBolder-iiF29`,
	"textNormal": `MobileLanguageInfo-textNormal-TPukq`,
	"textDarkBlue": `MobileLanguageInfo-textDarkBlue-MR91C`,
	"textLightBlue": `MobileLanguageInfo-textLightBlue-FRj8a`,
	"textLightSandleGreen": `MobileLanguageInfo-textLightSandleGreen-YYdry`,
	"textLightBrown": `MobileLanguageInfo-textLightBrown-SMOVS`,
	"textMediumMaroon": `MobileLanguageInfo-textMediumMaroon-qVBVS`,
	"textBrown": `MobileLanguageInfo-textBrown-xHkQA`,
	"textMaroon": `MobileLanguageInfo-textMaroon-CCm0L`,
	"textDarkBrown": `MobileLanguageInfo-textDarkBrown-nwbTy`,
	"textMediumBrown": `MobileLanguageInfo-textMediumBrown-XUC4j`,
	"textSkyBlue": `MobileLanguageInfo-textSkyBlue-dXyMb`,
	"textGray": `MobileLanguageInfo-textGray-B89Gv`,
	"errorMessage": `MobileLanguageInfo-errorMessage-k1dWe`,
	"userText": `MobileLanguageInfo-userText-Vhuwg`,
	"panelHeader": `MobileLanguageInfo-panelHeader-x0dsD`,
	"exportSection": `MobileLanguageInfo-exportSection-XQNON`,
	"exportSectionGridSub": `MobileLanguageInfo-exportSectionGridSub-_Cbub`,
	"exportText": `MobileLanguageInfo-exportText-WfYD0`,
	"exportLinkImg": `MobileLanguageInfo-exportLinkImg-gqarK`,
	"exportImg": `MobileLanguageInfo-exportImg-KCItX`,
	"linkBtn": `MobileLanguageInfo-linkBtn-wBV8y`,
	"table": `MobileLanguageInfo-table-o4jFh`,
	"tableRow": `MobileLanguageInfo-tableRow-il90z`,
	"tableCell": `MobileLanguageInfo-tableCell-XPnaz`,
	"formGroup": `MobileLanguageInfo-formGroup-rsiLY`,
	"marginTop0": `MobileLanguageInfo-marginTop0-lEYPg`,
	"marginBottom20": `MobileLanguageInfo-marginBottom20-hfSG6`,
	"bannerImageBg": `MobileLanguageInfo-bannerImageBg-Nii7B`,
	"bannerDelete": `MobileLanguageInfo-bannerDelete-rxkWc`,
	"exportLink": `MobileLanguageInfo-exportLink-_hVTc`,
	"seachContent": `MobileLanguageInfo-seachContent-iT1tZ`,
	"marginBottom9": `MobileLanguageInfo-marginBottom9-SsHSd`,
	"spaceTop52": `MobileLanguageInfo-spaceTop52-VqdJP`,
	"profileViewInner": `MobileLanguageInfo-profileViewInner-xDaBJ`,
	"profileViewMain": `MobileLanguageInfo-profileViewMain-QDdBL`,
	"profileViewlabel": `MobileLanguageInfo-profileViewlabel-HEDtB`,
	"profileViewMainContent": `MobileLanguageInfo-profileViewMainContent-SdQbn`,
	"reviewsFormStar": `MobileLanguageInfo-reviewsFormStar-UuJUm`,
	"addLanguageText": `MobileLanguageInfo-addLanguageText-jv2xL`
};
module.exports = ___CSS_LOADER_EXPORT___;
